// Imports: Dependencies
import { all, fork} from 'redux-saga/effects';
import audioTrackSagas from './audio-track-sagas'
import AdminDashBoard from './admin-dashboard'
import PageManagement from './page-management-sagas'
import QAManagement from './qa_management'
import SuperAdminManagement from './super-admin-sagas';
import CreatorTeam from './creator-saga';
// Redux Saga: Root Saga
export function* rootSaga () {
  yield all([
    fork(audioTrackSagas),
    fork(AdminDashBoard),
    fork(PageManagement),
    fork(QAManagement),
    fork(SuperAdminManagement),
    fork(CreatorTeam)
  ]);
};